import { createEntityAdapter } from '@reduxjs/toolkit';

import { FormState } from 'modules/form/types/FormState';

const formsAdapter = createEntityAdapter<FormState<unknown>, string>({
  selectId: (formState) => formState.key,
});

export default formsAdapter;
